var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal",class:{ active: _vm.isOpened }},[(_vm.isOpened)?_c('div',[_c('login',{attrs:{"close":_vm.closeModal}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }